const utm = {
    capture: ({ origin, token }) => {
        const queryString = window.location.search;
        if(!queryString) return
        const urlParams = new URLSearchParams(queryString);
        const source = urlParams.get('utm_source')
        const medium = urlParams.get('utm_medium')
        const campaign = urlParams.get('utm_campaign')
        const term = urlParams.get('utm_term')
        const content = urlParams.get('utm_content')
        const payload = {
            origin,
            token,
            params: {
                source,
                medium,
                campaign,
                term,
                content,
            }
        }
        localStorage.setItem("utm", JSON.stringify(payload))
    },
    get: () => {
        let payload = localStorage.getItem("utm")
        return JSON.parse(payload)
    },
    clear: () => {
    localStorage.removeItem('utm')
    }
}

export default utm


// WEBPACK FOOTER //
// ./src/App/utils/utm.js